const flightStore = {
  namespaced: true,
  state: {
    offers: null,
    orders: [],
  },
  mutations: {
    SET_OFFERS(state, offers) {
      state.offers = offers;
    },
    SET_ORDERS(state, orders) {
      state.orders = orders;
    },
  },
  actions: {
    getOffers({ commit }, offers) {
      commit("SET_OFFERS", offers);
    },
    setOrders({ commit }, orders) {
      commit("SET_ORDERS", orders);
    },
  },
  getters: {
    getOrderById: (state) => (id) => {
      return state.orders.find((order) => String(order.id) === String(id)) || null;
    },
  },
};

export default flightStore;
